<template>
        <v-btn v-if="link && !show" text @click="showPrivacy" v-bind="$attrs" v-text="label"></v-btn>
        <v-alert  :value="alert && show" v-else-if="!isApp && !link" class="ma-0 pt-0 text-caption text-center" fixed style="z-index:100;position:fixed;width:100%;bottom:0"
        tile dense color="grey lighten-3">
        <v-divider class="pb-2"></v-divider>
             We gebruiken cookies voor onze website en app. Als u doorgaat, gaan we er vanuit dat u ermee instemt. <v-btn text @click="showPrivacy" class="text-caption">Meer informatie</v-btn>
              <v-btn text @click="setCookie(false)" class="text-caption float-right">Akkoord</v-btn> 
              
        </v-alert>
</template>
<script>
  export default {
      props: {
        persistent: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        link: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        label: {
            type: String,
            default: function() {
                return 'Meer informatie';
            }
        },
    },
    data: () => ({
      alert: true
    }),
    computed: {
     show: {
         get(){
             return !$cookies.isKey('app-privacy')
         },
         set(value){
            this.setCookie(value)
         }
     },
     isApp() {
          return window.matchMedia('(display-mode: standalone)').matches ? true: false
      }
    },
    mounted() {
     
    },
     watch:{
     
     },
    methods: {
     showPrivacy(){
         window.open(this.$config.privacy)
     },
     setCookie(value){
         this.alert = value
         this.$cookies.remove('app-privacy');
        if (value===false) this.$cookies.set('app-privacy',value);
     }
    }
  }
</script>